export function formatCount(value: number): string {
  if (value >= 10000) {
    const wan = value / 10000;
    return `${wan.toFixed(1).replace(/\.0$/, '')}万`;
  }
  return String(value);
}

export interface StatusStyle {
  badge: string;
  dot: string;
}

export function statusStyle(status: string): StatusStyle {
  switch (status) {
    case '讨论中':
      return { badge: 'bg-primary-100 text-primary-700', dot: 'bg-primary-500' };
    case '等待回应':
      return { badge: 'bg-accent-100 text-accent-900', dot: 'bg-accent-500' };
    case '已有回应':
      return { badge: 'bg-secondary-100 text-secondary-900', dot: 'bg-secondary-500' };
    default:
      return { badge: 'bg-background-200 text-foreground-700', dot: 'bg-foreground-400' };
  }
}